import React from 'react';
import { Link } from 'react-router-dom';
import { getDiscountPercent } from '../data/productCatalog';

const placeholderImage = 'https://res.cloudinary.com/dcd6y2awx/image/upload/f_auto,q_auto/v1/PlantSeller/UI%20Images/plant-placeholder';

const getBadgeClass = (badge) => {
  if (!badge) return '';
  const lower = badge.toLowerCase();
  if (lower.includes('sale')) return 'badge-sale';
  if (lower.includes('popular') || lower.includes('best')) return 'badge-popular';
  if (lower.includes('premium')) return 'badge-premium';
  if (lower.includes('new')) return 'badge-new';
  return 'badge-default';
};

const ProductCard = ({ product, onAddToCart, linkTo }) => {
  const discount = getDiscountPercent(product);
  const isOutOfStock = product.inStock === false;

  return (
    <div className={`product-card ${isOutOfStock ? 'out-of-stock-card' : ''}`}>
      <Link to={linkTo || '#'} style={{ textDecoration: 'none', color: 'inherit' }}>
        <div className="product-card-image">
          <img
            src={product.image || product.images?.[0]?.url || placeholderImage}
            alt={product.name || product.plantName}
            onError={(e) => { e.target.src = placeholderImage; }}
            loading="lazy"
          />
          {product.badge && (
            <span className={`product-card-badge ${getBadgeClass(product.badge)}`}>
              {product.badge}
            </span>
          )}
          {discount > 0 && (
            <span className="product-card-discount">-{discount}%</span>
          )}
        </div>
        <div className="product-card-body">
          <span className="product-card-category">
            {product.categoryTitle || product.category}
          </span>
          <h4 className="product-card-name">{product.name || product.plantName}</h4>
          {product.description && (
            <p className="product-card-desc">{product.description}</p>
          )}
          <div className="product-card-price">
            <span className="price-current">₹{product.price}</span>
            {product.originalPrice && product.originalPrice > product.price && (
              <>
                <span className="price-original">₹{product.originalPrice}</span>
                <span className="price-discount">Save ₹{product.originalPrice - product.price}</span>
              </>
            )}
          </div>
        </div>
      </Link>
      <div className="product-card-action">
        <button
          className={`btn-add-cart ${isOutOfStock ? 'out-of-stock' : ''}`}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            if (!isOutOfStock && onAddToCart) onAddToCart(product);
          }}
          disabled={isOutOfStock}
        >
          {isOutOfStock ? (
            <>Out of Stock</>
          ) : (
            <>
              <i className="fas fa-shopping-cart"></i>
              Add to Cart
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default React.memo(ProductCard);
